module.exports = {"230127100":"木兰镇","230127101":"东兴镇","230127102":"大贵镇","230127103":"利东镇","230127104":"柳河镇","230127105":"新民镇","230127200":"建国乡","230127203":"吉兴乡","230127400":"兴隆林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230127.json
// module id = 774
// module chunks = 0